import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { cleanSearchingContinentsPaginated, continentClean } from "../../app/actions/catalogContinentActions";

import ReactTooltip from "react-tooltip";
import { useTracking } from "react-tracking";
import { useTranslation } from "react-i18next";
import DisplayNameAndRole from "./DisplayNameAndRole";

const NavbarIconsContinents = ({ page }) => {
  const dispatch = useDispatch();
  const { trackEvent } = useTracking();
  const { t } = useTranslation();

    const { isUserAuthenticated } = useSelector((state) => state.auth);

  const [activeIcon, setActiveIcon] = useState(null);

  const handleActiveIcon = (icon) => {
    
    if (icon === "new") {
      
      trackEvent({ component: "NewContinents", event: "NewContinents-Clicked" });
    } else if (icon === "list") {
      
      trackEvent({ component: "ListContinents", event: "ListContinents-Clicked" });
      dispatch(cleanSearchingContinentsPaginated());
    }

    dispatch(continentClean());
    setActiveIcon(icon);
  };

  const iconActiveStyle = (icon) => {
    if (activeIcon === icon) {
      return "icon-d-flex active";
    } else {
      return "icon-d-flex";
    }
  };

  return (
    <div className="d-flex justify-content-between align-items-center flex-nowrap gradient-custom-sky custom-nav-height">
      {isUserAuthenticated && (
        <DisplayNameAndRole />
      )}
      {page === "listContinents" && (
        <Link
          data-tip
          data-for="newContinentsTip"
          to="/admin-continent/new-continent"
          className="p-2 bd-highlight"
          onClick={() => handleActiveIcon("new")}
        >
          <i className={`fa fa-plus-square fa-2x ${iconActiveStyle("new")}`} aria-hidden="true" />
        </Link>
      )}
      {page === "newContinents" && (
        <Link
          data-tip
          data-for="listContinentsTip"
          to="/admin-continent/"
          className="p-2 bd-highlight"
          onClick={() => handleActiveIcon("list")}
        >
          <i className={`fa fa-table fa-2x ${iconActiveStyle("list")}`} aria-hidden="true" />
        </Link>
      )}
      {page === "editContinents" && (
        <div className="navbar-module-actions">
          <Link
            data-tip
            data-for="listContinentsTip"
            to="/admin-continent/"
            className="p-2 bd-highlight"
            onClick={() => handleActiveIcon("list")}
          >
            <i className={`fa fa-table fa-2x ${iconActiveStyle("list")}`} aria-hidden="true" />
          </Link>
          <Link
            data-tip
            data-for="newContinentsTip"
            to="/admin-continent/new-continent"
            className="p-2 bd-highlight"
            onClick={() => handleActiveIcon("new")}
          >
            <i className={`fa fa-plus-square fa-2x ${iconActiveStyle("new")}`} aria-hidden="true" />
          </Link>
        </div>
      )}

      <ReactTooltip id="newContinentsTip" place="left" effect="solid">
        {t("admin-continent.page.register")}
      </ReactTooltip>
      <ReactTooltip id="listContinentsTip" place="left" effect="solid">
        {t("admin-continent.page.list")}
      </ReactTooltip>
    </div>
  );
};

export default NavbarIconsContinents;
